import React, { useEffect, useState } from "react";
import { FiFacebook, FiTwitter, FiInstagram } from "react-icons/fi";
import {BsTwitterX } from 'react-icons/bs'

import { Newsletter } from "../../components";
import "./Footer.css";
import { images } from "../../constants";

const Footer = () => {
  const year = new Date().getFullYear();

  const [ currentYear, setCurrentYear ] = useState(year);

  useEffect(() => {
    setCurrentYear(year)
  }, [year]);

  return (
        <div className="app__footer section__padding">
          <Newsletter />
          <div className="app__footer-links">
            <div className="app__footer-links_contact">
              <h1 className="app__footer-headtext">Contact Us</h1>
              <p className="p__opensans">555 Destination Av, Everywhere USA</p>
              <p className="p__opensans"> 1-234-567-8900</p>
            </div>
            <div className="app__footer-links_logo">
              <img
                src={images.spoon}
                alt="spoon"
                className="spoon__img"
              />
              <div className="app__footer-links_icons">
                <FiFacebook />
                <FiTwitter />
                <FiInstagram />
                <BsTwitterX/>
              </div>
            </div>
          </div>
          <div className="footer__copyright">
            <p className="p__opensans">{currentYear} Sheafify. All Right Reserved</p>
          </div>
        </div>
  )
  };

export default Footer;
